import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { NovoCondicaoPagamentoTipoMultiselectComponent } from './novo-condicao-pagamento-tipo-multiselect.component';

@NgModule({
  imports: [SharedModule],
  declarations: [NovoCondicaoPagamentoTipoMultiselectComponent],
  exports: [NovoCondicaoPagamentoTipoMultiselectComponent]
})
export class NovoCondicaoPagamentoTipoMultiselectModule {}
